package com.essntl.uikit.components.scroll

import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.lazy.grid.LazyGridState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier

@Composable
fun EsVerticalScrollbar(
    scrollState: ScrollState,
    modifier: Modifier = Modifier,
    reverseLayout: Boolean = false,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() }
) = EsVerticalScrollbarPlatform(
    scrollState = scrollState,
    modifier = modifier,
    reverseLayout = reverseLayout,
    interactionSource = interactionSource
)

@Composable
fun EsVerticalScrollbar(
    lazyListState: LazyListState,
    modifier: Modifier = Modifier,
    reverseLayout: Boolean = false,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() }
) = EsVerticalScrollbarPlatform(
    lazyListState = lazyListState,
    modifier = modifier,
    reverseLayout = reverseLayout,
    interactionSource = interactionSource
)

@Composable
fun EsVerticalScrollbar(
    lazyGridState: LazyGridState,
    modifier: Modifier = Modifier,
    reverseLayout: Boolean = false,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() }
) = EsVerticalScrollbarPlatform(
    lazyGridState = lazyGridState,
    modifier = modifier,
    reverseLayout = reverseLayout,
    interactionSource = interactionSource
)

@Composable
internal expect fun EsVerticalScrollbarPlatform(
    scrollState: ScrollState,
    modifier: Modifier = Modifier,
    reverseLayout: Boolean = false,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() }
)

@Composable
internal expect fun EsVerticalScrollbarPlatform(
    lazyListState: LazyListState,
    modifier: Modifier = Modifier,
    reverseLayout: Boolean = false,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() }
)

@Composable
internal expect fun EsVerticalScrollbarPlatform(
    lazyGridState: LazyGridState,
    modifier: Modifier = Modifier,
    reverseLayout: Boolean = false,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() }
)